import { IconButton } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

const CircularIconButton = styled(IconButton, { shouldForwardProp: (prop) => prop !== 'isEditing' })`
    width: 32px;
    height: 32px;
    background: none;
    margin-top: ${(props) => props.isEditing && '20px'};
    border-radius: var(--chakra-radii-base);
    align-self: center;

    span {
        margin-right: 0px;
    }

    &:hover {
        background: none;

        svg path {
            fill: var(--chakra-colors-blue-400);
        }
    }

    &:disabled,
    &:disabled:hover {
        width: 32px;
        height: 32px;
        border-radius: var(--chakra-radii-full);
        background: none;

        span {
            opacity: 1;
        }

        circle {
            fill: var(--chakra-colors-gray-100);
        }

        svg path {
            fill: none;
        }
    }

    svg path {
        fill: var(--chakra-colors-gray-600);
    }
`;

export default CircularIconButton;
